class PickStoreModal {
    constructor() {
        this.init();
    }

    /**
     * Main method. Used for setting up other methods
     * 
     */
    init() {
        let $ = jQuery;
        let self = this;

        $(document).ready(function () {
            $('.mm__pick-store-modal.product-modal').delegate('.store-card', 'click', function () {
                if($(!this).hasClass('is-active')) {
                    $(this).addClass('is-active')
                } else {
                    $(this).removeClass('is-active')
                }
                $(this).children('.btn-wrapper').slideToggle(300);
            });

            $('.mm__pick-store-modal.product-modal .close-to-you').click(function () { 
                self.searchByPosition(self);
            });

            self.searchByInput();
        });
    }

    /**
     * Responsible for handling user input.
     * 
     */
    searchByInput() {
        let $ = jQuery;
        let self = this;

        // Stop form submit
        $('.mm__pick-store-modal.product-modal #pick-store').submit(function (e) {
            e.preventDefault();
        });

        let input = document.getElementById('pick-product-store-input');
        let options = {
            componentRestrictions: {
                country: 'se',
            },
        };

        // input.addEventListener('keyup', function(e) {
        //     if (e.keyCode === 13) {
        //         const query = input.value;
        //         if (query) {
        //             self.showResult(self, query);
        //         }
        //     }
        // });
        if(input instanceof HTMLElement){
            const AUTOCOMPLETE = new google.maps.places.Autocomplete(input, options);
            AUTOCOMPLETE.setFields(['address_components', 'geometry', 'icon', 'name']);
            AUTOCOMPLETE.addListener('place_changed', function () {
                const PLACE = AUTOCOMPLETE.getPlace();

                if (PLACE.length == 0) {
                    console.log('Did not find any places');
                    return;
                }

                if (typeof PLACE.geometry === 'undefined') {
                    console.log('Not a valid position');
                    return;
                }

                const POS = {
                    lat: PLACE.geometry.location.lat(),
                    lng: PLACE.geometry.location.lng(),
                };

                self.showResult(self, POS);
            });
        }
    }

    /**
     * Responsible for handling positional coordinates
     * 
     * @param {this} self 
     */
    searchByPosition(self) {
        // Try HTML5 geolocation.
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                const POS = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };

                self.showResult(self, POS);
            }, function () {
                alert("Error: The Geolocation service failed.");
            });
        } else {
            // Browser doesn't support Geolocation
            alert("Error: Your browser doesn't support geolocation.");
        }
    }

    /**
     * Responsible for displaying results based on either search coordinates or positional coordinates
     * 
     * @param {this} self 
     * @param {object} origin 
     */
    showResult(self, origin) {
        let $ = jQuery;

        $('.mm__pick-store-modal.product-modal .store-card').each(function (i, el) {
            // Display all elements for each request
            if ($(this).hasClass('is-hidden')) {
                $(this).removeClass('is-hidden');
            }

            let destination = [{ lat: parseFloat($(this).data('lat')), lng: parseFloat($(this).data('lng')) },];

            let service = new google.maps.DistanceMatrixService();
            let request = {
                origins: [origin],
                destinations: destination,
                travelMode: google.maps.TravelMode.DRIVING,
                unitSystem: google.maps.UnitSystem.METRIC,
                avoidHighways: false,
                avoidTolls: false,
            }

            setTimeout(() => {
                service
                .getDistanceMatrix(request)
                .then(res => {
                    if (res.rows[0].elements.length > 0) {

                        $(this).attr('data-distance',res.rows[0].elements[0].distance.value);

                        // If the distance from the origin to the destination is more the 100 kilometers, hide it from the list
                        if (res.rows[0].elements[0].distance.value > 100000) {
                            $(this).addClass('is-hidden');
                        }

                    } else {
                        window.alert('No results found');
                    }
                })
            }, 6 * i );

        });

        setTimeout(() => {
            let totalStoreNumber = $('.mm__pick-store-modal.product-modal .store-card').length;
            let filteredStoreNumber = $('.mm__pick-store-modal.product-modal .store-card:not(.is-hidden)').length;
            $('.mm__pick-store-modal.product-modal .number-of-stores').empty();
            $('.mm__pick-store-modal.product-modal .number-of-stores').text(`${filteredStoreNumber} av ${totalStoreNumber} butiker`);

            // Show nearest store first in store location listing
            if($('.mm__pick-store-modal.product-modal .stores-wrapper').length){
                var $wrapper = $('.mm__pick-store-modal.product-modal .stores-wrapper');
                $wrapper.find('.store-card:not(.is-hidden)').sort(function (a, b) {
                    return +a.dataset.distance - +b.dataset.distance;
                })
                .appendTo( $wrapper );
            }

        }, 1000 );
    }
}

export default PickStoreModal;
